<template>
  <div class="invoice-clickable-lot-no">
    <a href="javascript:void(0)" @click="onClick">
      {{ displayName }}
    </a>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";

  const {mapActions} = createNamespacedHelpers('lots');

  export default {
    name: "ClickableLotNo",
    props: {
      obj: {
        type: Object,
        required: true,
        default: () => {
          return {}
        }
      },
      isFinancialItem: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      displayName() {
        if (!this.obj) {
          return ''
        }

        if (this.isFinancialItem && this.obj.lot) {
          return this.obj.lot.lot_no
        }

        return ''
      }
    },
    methods: {
      ...mapActions(['showLotInfoModal']),
      onClick() {
        if (this.isFinancialItem && this.obj.lot) {
          this.showLotInfoModal({lot_uuid: this.obj.lot.uuid})
        }
      }
    }
  }
</script>

<style scoped>

</style>
